import { LineChart, Line, ResponsiveContainer } from "recharts";
import { Wallet } from "lucide-react";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import { totalIncomeConfig } from "./data";

export function TotalIncome() {
  const { t } = useTranslation();
  const config = totalIncomeConfig;

  return (
    <div className={`card-shadow rounded-2xl ${config.bg} p-5`}>
      <div className="flex items-center justify-between gap-4">
        <div className="min-w-0">
          <div className="flex items-center gap-2.5">
            <div className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg ${config.iconBg}`}>
              <Wallet size={16} className={config.iconColor} strokeWidth={1.75} />
            </div>
            <p className="text-sm font-medium text-muted-foreground">{t.crm.totalIncome}</p>
          </div>
          <p className="mt-3 text-2xl font-bold text-foreground">{config.value}</p>
          <p className={`mt-0.5 text-xs font-medium ${config.changeColor}`}>{t.crm.changeIncome}</p>
        </div>
        <div className="w-[90px] shrink-0">
          <ResponsiveContainer width="100%" height={60}>
            <LineChart data={config.chartData}>
              <Line type="monotone" dataKey="v" stroke={config.chartColor} strokeWidth={2} dot={false} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
